import React, { useState } from 'react';
import { Button, Message, ProfilePicture } from '@getro/rombo';
import { Mail } from 'lucide-react';
import { useHistory, useParams, Redirect } from 'react-router-dom';
import { Box, Text, Flex } from 'rebass/styled-components';

import AuthSideBar from 'components/atoms/authSideBar';
import { SocialOAuthButtons } from '../../../components/molecules/socialOAuthButtons';
import { openChat } from '../../../helpers/supportChat';
import { useOnboarding } from '../hooks/useOnboarding';

export const SignUp = () => {
  const [oAuthError, setOAuthError] = useState(null);
  const history = useHistory();
  const { networkSlug } = useParams();
  const { user, activeNetwork, profileMode, skipSignUp } = useOnboarding();

  if (skipSignUp) {
    return <Redirect to={`/networks/${networkSlug}/welcome/onboarding/profile/${profileMode}`} />;
  }

  const onClickSignUp = (mode) => {
    history.push(`/networks/${networkSlug}/welcome/onboarding/profile/${mode}`);
  };

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: ['1fr', '1fr', '1fr 480px'], height: '100%' }}>
      <Flex sx={{ width: '100%', height: '100%', alignItems: 'center' }}>
        <Flex
          sx={{
            gap: '56px',
            flexDirection: 'column',
            px: '16px',
            width: '100%',
            maxWidth: '380px',
            mx: 'auto',
            height: 'auto',
          }}
        >
          <Flex width="100%" sx={{ gap: '16px', flexDirection: 'column', alignItems: 'flex-start' }}>
            <ProfilePicture
              width="48px"
              height="48px"
              variant="square"
              src={activeNetwork.logoUrl}
              name={activeNetwork.name}
              sx={{ flex: '0 0 auto' }}
            />
            <Text fontSize="24px" fontWeight="700" color="text.dark">
              {`Join the ${activeNetwork.name} network`}
            </Text>
          </Flex>
          <Box>
            <SocialOAuthButtons
              isInvite
              onSuccess={() => {
                onClickSignUp('social');
                setOAuthError(null);
              }}
              onError={(e) => {
                setOAuthError(e);
              }}
            />
            <Button
              mt="8px"
              icon={Mail}
              variant="secondary"
              width="100%"
              sx={{ gap: '16px', justifyContent: 'center' }}
              onClick={() => onClickSignUp(user?.hasPassword || user?.oauthProviders.length > 0 ? 'password' : 'email')}
            >
              Continue with email
            </Button>
            {!!oAuthError && (
              <Message
                mt="8px"
                type="error"
                content={
                  oAuthError?.status === 401 ? (
                    oAuthError.data?.error
                  ) : (
                    <Text>
                      There was an unexpected error, please try again or{' '}
                      <Text as="span" sx={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={openChat}>
                        contact us
                      </Text>
                      .
                    </Text>
                  )
                }
              />
            )}
          </Box>
          <Text fontSize="14px" fontWeight="400" color="text.main" textAlign="center">
            Getro is currently invite-only. If you don’t have an invitation, check in with your network admin.
          </Text>
        </Flex>
      </Flex>
      <Box sx={{ display: ['none', 'none', 'block'] }}>
        <AuthSideBar />
      </Box>
    </Box>
  );
};
